import axios from 'axios'
import { notifySuccess } from 'utils/common'

class Client {
  constructor (data) {
    this.id = data.id
    this.imei = data.lookupKey // string 定位连接的key,这里就是IMEI
    this.remoteHost = data.remoteHost // string 设备这次连接使用的IP
    this.remotePort = data.remotePort // number 设备这次连接开始的端口
    this.isActive = data.active // boolean 设备连接是否是活动的
    this.isConnected = data.connected // boolean 设备是否已经完成连接（有的可能在连接中）
    this.isClosed = data.closing // boolean 设备连接是否已关闭
    this.isIdle = data.bothIdle // boolean 连接的可读写通道是否都是空闲的
    this.isReadable = data.readerIdle // boolean 连接的可读通道是否空闲
    this.isWritable = data.writerIdle // boolean 连接的可写通道是否空闲
    this.createdAt = data.creationTime // date 设备连接时间戳。毫秒数
  }
}

/**
 * 获取客户端信息
 * @return {Number} port 服务器端口号
 * @return {Object} clients 客户端列表
 */
const mockData = {
  port: 36001,
  clients: [
    {
      id: 1,
      lookupKey: '999998807270845',
      remoteHost: '127.0.0.1',
      remotePort: 65376,
      active: true,
      connected: true,
      closing: false,
      creationTime: 1502761074296,
      bothIdle: false,
      readerIdle: false,
      writerIdle: false
    }
  ]
}

export const getServerData = async () => {
  // const { data: { port, clients } } = await axios.get('v1/mws-server')
  await new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 2000)
  })
  const { port, clients } = mockData
  const list = clients.map(item => new Client(item))
  return { port, list }
}

/**
 * 下发通用指令
 * @param {*Object} data 表单
 */
export const sendCommand = async (data) => {
  await axios.post('v1/mws-server', data)
  notifySuccess('下发成功')
}

/**
 * 设置频段
 * @param {*Object} data 表单
 */
export const setFreq = async (data) => {
  await axios.post('v1/mws-server/set-nidfreq', data)
  notifySuccess('下发成功')
}

/**
 * 重启设备
 * @param {*Object} data 表单
 */
export const restartServer = async (options) => {
  await axios.post('v1/mws-server/restart', options)
  notifySuccess('下发成功')
}

/**
 * 断开设备
 * @param {*String} imei 需要断开的设备的imei。设置为'idle'，表示断开所有空连接
 */
export const destroyClient = async (imei) => {
  await axios.delete(`v1/mws-server/clients/${imei}`)
  notifySuccess('断开成功')
}
